import { Info } from "lucide-react";

export enum BannerType {
  NEUTRAL,
  ERROR,
  SUCCESS,
}

const Banner = ({
  children,
  type = BannerType.NEUTRAL,
}: {
  children: React.ReactNode;
  type?: BannerType;
}) => (
  <div
    className={[
      "px-4 py-3 rounded-lg flex gap-2",
      (() => {
        if (type === BannerType.ERROR)
          return "bg-[#fce8eb] text-[#db394a] text-sm";

        if (type === BannerType.SUCCESS) return "bg-green-500";

        return "bg-[#333]";
      })(),
    ].join(" ")}
  >
    <div className="mt-[3px]">
      <Info color="#db394a" size={18} />
    </div>
    <div className="grow">{children}</div>
  </div>
);

export default Banner;
